import React from "react"
import Layout from "../components/Layout"

const Tags = () => {
  return (
    <Layout>
      <main className="page">
        <h1>Tags page</h1>
      </main>
    </Layout>
  )
}

export default Tags
